interface SectionHeadProps {
  eyebrow: string;
  title: string;
  desc?: string;
  light?: boolean;
}

export default function SectionHead({ eyebrow, title, desc, light }: SectionHeadProps) {
  return (
    <div className="mx-auto mb-10 max-w-3xl text-center md:mb-14">
      <span
        className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-widest ${
          light ? "bg-accent-500 text-foreground-950" : "bg-primary-100 text-primary-700"
        }`}
      >
        <i className="ri-flashlight-fill text-sm" aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2
        className={`font-serifsc mt-5 text-3xl font-black tracking-tight md:text-4xl ${
          light ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p className={`mt-4 text-base leading-relaxed md:text-lg ${light ? "text-background-200" : "text-foreground-600"}`}>
          {desc}
        </p>
      )}
    </div>
  );
}